import {
    getCoreRowModel,
    getFilteredRowModel,
    getSortedRowModel,
    TableOptions,
    useReactTable,
} from '@tanstack/react-table'

export const useTable = <T>(
    options: Pick<
        TableOptions<T>,
        | 'data'
        | 'columns'
        | 'onRowSelectionChange'
        | 'getRowId'
        | 'enableMultiRowSelection'
        | 'state'
        | 'enableGlobalFilter'
        | 'globalFilterFn'
        | 'manualSorting'
        | 'manualFiltering'
        | 'onSortingChange'
        | 'onColumnFiltersChange'
    >
) =>
    useReactTable({
        ...options,
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getSortedRowModel: getSortedRowModel(),
        state: options.state,
    })
